import api from "api/api";
import { buildQueryParams, commonParams } from "utils/queriesHelper";

const fetchMutualDashboardData = async (endpoint, params) => {
  const queryString = buildQueryParams({
    ...commonParams(params),
  });
  return await api.get(`/dashboard/mutual/${endpoint}?${queryString}`);
};

export const getMutualDashboardICQuery = (params) =>
  fetchMutualDashboardData("ic", params);

export const getMutualDashboardFDMQuery = (params) =>
  fetchMutualDashboardData("fdm", params);

export const getMutualDashboardEDQuery = (params) =>
  fetchMutualDashboardData("ed", params);

export const getMutualDashboardExitsQuery = (params) =>
  fetchMutualDashboardData("ko", params);

export const getMutualDashboardCLQuery = (params) =>
  fetchMutualDashboardData("cl", params);

export const getMutualDashboardOKQuery = (params) =>
  fetchMutualDashboardData("ok", params);

export const getMutualDashboardExportQuery = async ({ queryParams, section }) =>
  api.getBlob(
    `/dashboard/mutual/${section}/export?${buildQueryParams(queryParams)}`
  );
